import React, { useState } from 'react';
import { useEmailTemplateLibrary } from '../emails/useData';
import TemplatesLibraryPanel from '../emails/components/TemplatesLibraryPanel';
import ShareTemplateFolderModal from '../emails/components/ShareTemplateFolderModal';
import { useNotification } from '../../contexts/NotificationContext';

const List: React.FC = () => {
  const { showSuccess, showError } = useNotification();
  const {
    company,
    personal,
    shared,
    isLoading,
    mutate: mutateTemplateLibrary,
  } = useEmailTemplateLibrary();
  const [shareTemplateFolderOpen, setShareTemplateFolderOpen] = useState<{
    folderId: number;
    folderName: string;
  } | null>(null);

  return (
    <div className="h-full min-h-0 flex flex-col overflow-hidden">
      <TemplatesLibraryPanel
        company={company}
        personal={personal}
        shared={shared}
        isLoading={isLoading}
        showImport
        onImported={async () => {
          await mutateTemplateLibrary();
        }}
        onSuccess={showSuccess}
        onError={showError}
        onShareTemplateFolder={(f) => setShareTemplateFolderOpen({ folderId: f.id, folderName: f.name })}
      />

      {shareTemplateFolderOpen != null && (
        <ShareTemplateFolderModal
          isOpen
          onClose={() => setShareTemplateFolderOpen(null)}
          folderId={shareTemplateFolderOpen.folderId}
          folderName={shareTemplateFolderOpen.folderName}
          onShared={() => void mutateTemplateLibrary()}
        />
      )}
    </div>
  );
};

export default List;
